import React from 'react';

import * as messages from '@radnuc/messages';
import * as d3 from 'd3';
import {Config} from './Config';
import { t } from 'i18next';
import './i18n';
import {checkSnoozeState} from './SnoozeIsotopeDisplay'
import strong_lines_list from './spectrum_strong_lines_RFG';

import {positionType} from './SpectrumDisplay'
import './SpectrumDisplay.css'

//type strong_lines = {name: string, name_hyphen: string, lines: number[]}
//type GammaSpectrum = { time: number, sum: number, spectrum: number[], livetime: number }
//type DrifttimeCountPair = { drift_time: number, count_pos: number, count_neg: number }
//type NeutronData = { time: number, count: number, livetime: number }
type BioCountData = { time: number, count: number}
//type ImsSpectrum = { time: number, pos: number[], neg: number[] }

export interface BioDisplayProperty {
    gammaInLanePosition: number | undefined,
    neutronInLanePosition: number | undefined,
}
export interface BioDisplayInterface {
    inLanePositionInit: BioDisplayProperty,
    updateInLanePosition: (position: BioDisplayProperty) => void,
}

export interface BioDisplayProps {
    lifReadings: messages.SigmaPlusBio.LIFReading[] | null,
    //raidRadings?: messages.Chem.RaidReading[] | null,
    //data2: messages.Rad.NeutronReading[] | null,
    //pcsResults: messages.Rad.PCSResult[] | null,
    liveStream: boolean,
    replayTime?: Date,
    isPrimary?: boolean,
    lanePosition?: number,
    multiLane?: boolean,
    showByPositionType?: positionType,
    spectrumDisplayInterface? : BioDisplayInterface,
    config?: Config,
}

export interface BioDisplayState {
    plotTimeRange: [number, number] | undefined
    liveSpectrumSumStartTime: number
}

export class BioDisplay extends React.Component<BioDisplayProps, BioDisplayState> {
    //spectra: GammaSpectrum[];
    //sourceSpectrum: DrifttimeCountPair[];
    bioLargeCount: BioCountData[];
    bioSmallCount: BioCountData[];
    //imsSpectra: ImsSpectrum[];
    timestamps: number[];
    //counts: number[][];
    //neutronCounts: NeutronData[];
    min_channel_rate: number = 1e1;
    //drift_time: number[];
    //plotTimeRange: [number,number] | undefined;
    lastTimeForceRedraw: number = 0;
    dominantIsotope: string | null = null;
    //gamma_max_in_lane_pos: number | undefined;
    gamma_possible_in_lane_pos: number[] = [];
    //neutron_max_in_lane_pos: number | undefined;
    neutron_possible_in_lane_pos: number[] = [];
    gammaInLanePosition?: number;
    neutronInLanePosition?: number;
    possible_lane_pos: number[] = [];
    lanePosition?: number;

    constructor(props: BioDisplayProps) {
        super(props)

        this.state = {
            plotTimeRange: undefined,
            liveSpectrumSumStartTime: 0
        }
        this.bioLargeCount = [];
        this.bioSmallCount = [];
        //this.imsSpectra = [];
        //this.counts = [];
        //this.neutronCounts = [];
        this.timestamps = []
        /*
        this.drift_time = [];
        for (var i = 0; i < 1024; ++i) {
            this.drift_time.push(0.0303*i);
        }
        this.sourceSpectrum = [];
        */

        this.setSpectrumSumRange = this.setSpectrumSumRange.bind(this);
        this.setLiveSpectrumSumStartTime = this.setLiveSpectrumSumStartTime.bind(this);

        //this.calcGammaSpectrumAndCount = this.calcGammaSpectrumAndCount.bind(this);
    }

    componentDidUpdate(prevProps: BioDisplayProps) {

        this.calcBioCount();

        if(this.props.spectrumDisplayInterface !== undefined){
            this.gammaInLanePosition = this.props.spectrumDisplayInterface.inLanePositionInit.gammaInLanePosition;
            this.neutronInLanePosition = this.props.spectrumDisplayInterface.inLanePositionInit.neutronInLanePosition;
        }

    }

    addVector(a: number[], b: number[] | null) {
        if (b !== null)
            return a.map((e, i) => e + b[i]);
        else
            return a;
    }

    setSpectrumSumRange(start_time: number | null, end_time: number | null) {
        const timenow = Date.now();
        if (timenow > this.lastTimeForceRedraw + 50) {
            if (start_time !== null && end_time !== null) {
                if (start_time <= end_time) {
                    this.setState(() => ({
                        plotTimeRange: [start_time, end_time]
                    }));
                    //console.log("start time: " + start_time.valueOf() + " end time " + end_time.valueOf());
                } else {
                    this.setState(() => ({
                        plotTimeRange: undefined
                    }));
                }
            } else {
                this.setState(() => ({
                    plotTimeRange: undefined
                }));
            }
            this.lastTimeForceRedraw = timenow;
        }
    }

    setLiveSpectrumSumStartTime(start_time: number){
        const timenow = Date.now();
        if (timenow > this.lastTimeForceRedraw + 50) {
            this.setState(() => ({
                liveSpectrumSumStartTime: start_time
            }));
            this.lastTimeForceRedraw = timenow;
        }
    }


    calcBioCount(){
        this.bioLargeCount = [];
        this.bioSmallCount = [];
        if (this.props.lifReadings !== null && this.props.lifReadings.length > 0) {
            this.props.lifReadings.forEach((data) => {

                let count_largebio = 0.0;
                let count_smallbio = 0.0;
                if(data.number_of_biological_particles !== null && data.number_of_biological_particles.length >= 0){
                    count_largebio = data.number_of_biological_particles[1];
                    //count_largebio = Number(count_largebio);
                    count_smallbio = data.number_of_biological_particles[0]; //N.B. Small bio count comes before large bio count
                    //count_smallbio = Number(count_largebio);
                }
                let time = data.acquisition_start;
                time = Number(time);
                const result_largebio = {
                    time: time,
                    count: count_largebio
                };
                const result_smallbio = {
                    time: time,
                    count: count_smallbio
                };
                this.bioLargeCount.push(result_largebio);
                this.bioSmallCount.push(result_smallbio);
            });
        }
        this.bioLargeCount = this.bioLargeCount.sort(function (x, y) { return d3.ascending(x.time, y.time); });
        this.bioSmallCount = this.bioSmallCount.sort(function (x, y) { return d3.ascending(x.time, y.time); });

    };

    handleGammaDetSelection(selection?:number){
            this.gammaInLanePosition = selection;
    }
    handleNeutronDetSelection(selection?:number){
            this.neutronInLanePosition = selection;
    }

    makeDetectorSelectDisplay(){
        let detectorSelectDisplay;
        let gammaButtons:JSX.Element[] = [];
        //if(this.gamma_max_in_lane_pos!==undefined){
        //    for(var i=0; i<=this.gamma_max_in_lane_pos;i++){
        if(this.gamma_possible_in_lane_pos.length > 0){
            this.gamma_possible_in_lane_pos.forEach((i)=>{
                const inLanePos = i;
                let thisSelectedClass;
                if(this.gammaInLanePosition === inLanePos )
                    thisSelectedClass = 'selected';
                const this_button =
                    <div key={inLanePos} className={"tiny-button "+thisSelectedClass}
                                onClick={() => this.handleGammaDetSelection(inLanePos)}>{inLanePos}</div>
                gammaButtons.push(this_button)
            });
            let allSelectedClass;
            if(this.gammaInLanePosition === undefined)
                allSelectedClass = 'selected';
            const all_button =
                <div key={100} className={"tiny-button "+allSelectedClass}
                            onClick={() => this.handleGammaDetSelection()}>All</div>
            gammaButtons.push(all_button)
        }

        let neutronButtons:JSX.Element[] = [];
        //if(this.neutron_max_in_lane_pos!==undefined){
        //    for(var i=0; i<=this.neutron_max_in_lane_pos;i++){
        if(this.neutron_possible_in_lane_pos.length > 0){
            this.neutron_possible_in_lane_pos.forEach((i)=>{
                const inLanePos = i;
                let thisSelectedClass;
                if(this.neutronInLanePosition === inLanePos )
                    thisSelectedClass = 'nselected';
                const this_button =
                    <div key={inLanePos} className={"tiny-button "+thisSelectedClass}
                                onClick={() => this.handleNeutronDetSelection(inLanePos)}>{inLanePos}</div>
                neutronButtons.push(this_button)
            });
            let allSelectedClass;
            if(this.neutronInLanePosition === undefined)
                allSelectedClass = 'nselected';
            const all_button =
                <div key={100} className={"tiny-button "+allSelectedClass}
                            onClick={() => this.handleNeutronDetSelection()}>All</div>
            neutronButtons.push(all_button)
        }
        detectorSelectDisplay =
            <div id='detector-select-container' style={{ display: 'flex', flexDirection: 'row', justifyContent:'flex-end', marginRight:'5px'}}>
                <span style={{color:'olivedrab',marginRight:'10px'}}>Gamma Detector Position</span>{gammaButtons}
                <div style={{marginRight:'20px'}}/>
                <span style={{color:'steelblue',marginRight:'10px'}}>Neutron Detector Position</span>{neutronButtons}
            </div>
        return(
            <div style={{position: 'relative'}}>
            {detectorSelectDisplay}
            </div>
        )

    }
    handleLaneSelection(selection?:number){
            this.lanePosition = selection;
    }
    makeLaneSelectDisplay(){
        let laneSelectDisplay;
        let laneButtons:JSX.Element[] = [];
        if(this.possible_lane_pos.length > 0){
            this.possible_lane_pos.forEach((i)=>{
                const lanePos = i;
                let thisSelectedClass;
                if(this.lanePosition === lanePos )
                    thisSelectedClass = 'selected';
                const this_button =
                    <div key={lanePos} className={"tiny-button "+thisSelectedClass}
                                onClick={() => this.handleLaneSelection(lanePos)}>{lanePos}</div>
                laneButtons.push(this_button)
            });
            let allSelectedClass;
            if(this.lanePosition === undefined)
                allSelectedClass = 'selected';
            const all_button =
                <div key={100} className={"tiny-button "+allSelectedClass}
                            onClick={() => this.handleLaneSelection()}>All</div>
            laneButtons.push(all_button)
        }

        laneSelectDisplay =
            <div id='detector-select-container' style={{ display: 'flex', flexDirection: 'row', justifyContent:'flex-end', marginRight:'5px'}}>
                <span style={{color:'white',marginRight:'10px'}}>Position</span>{laneButtons}
            </div>
        return(
            <div style={{position: 'relative'}}>
            {laneSelectDisplay}
            </div>
        )

    }

    handlePositionSelection(selection?:number){
            this.gammaInLanePosition = selection;
            this.neutronInLanePosition = selection;
            if(this.props.spectrumDisplayInterface){
                const spectrumDisplayPositions:BioDisplayProperty = {gammaInLanePosition:this.gammaInLanePosition,
                                                                          neutronInLanePosition:this.neutronInLanePosition}
                this.props.spectrumDisplayInterface.updateInLanePosition(spectrumDisplayPositions);
            }

            //if(this.neutron_possible_in_lane_pos.length > 1){
            //    this.neutronInLanePosition = selection;
            //} else {
            //    this.neutronInLanePosition = undefined;
            //}

    }
    makePositionSelectDisplay(){
        let positionSelectDisplay;
        let positionButtons:JSX.Element[] = [];
        let positionNameLUT:{[position:number]:string}|undefined;
        if(this.props.showByPositionType === positionType.BEARING){
            positionNameLUT = {0:'L',1:'R'}
        } else if(this.props.showByPositionType === positionType.IN_LANE){
            positionNameLUT = {0:'B',1:'T'}
        } else {
            positionNameLUT = undefined;
        }

        const combined_possible_in_lane_pos = Array.prototype.concat(this.gamma_possible_in_lane_pos,this.neutron_possible_in_lane_pos).filter((v, i, a) => a.indexOf(v) === i);;
        if(combined_possible_in_lane_pos.length > 0 ){
            combined_possible_in_lane_pos.sort((a,b) => a-b).forEach((i)=>{
                const lanePos = i;
                let lanePosString;
                if(lanePos !== null){
                    lanePosString = lanePos.toFixed(0);
                }
                if(positionNameLUT !== undefined){
                    lanePosString = t(positionNameLUT[lanePos],{ns:'trans'});
                }
                let thisSelectedClass;
                if(this.gammaInLanePosition === lanePos )
                    thisSelectedClass = 'selected';
                const this_button =
                    <div key={lanePos} className={"tiny-button "+thisSelectedClass}
                                onClick={() => this.handlePositionSelection(lanePos)}>{lanePosString}</div>
                if(lanePos !== null)
                    positionButtons.push(this_button)
            });
            let allSelectedClass;
            if(this.gammaInLanePosition === undefined)
                allSelectedClass = 'selected';
            const all_button =
                <div key={100} className={"tiny-button "+allSelectedClass}
                            onClick={() => this.handlePositionSelection()}>{t('All',{ns:'trans'})}</div>
            positionButtons.push(all_button)
        }

        positionSelectDisplay =
            <div id='detector-select-container' style={{ display: 'flex', flexDirection: 'row', justifyContent:'flex-end', marginRight:'5px'}}>
                <span style={{color:'white',marginRight:'10px'}}>{t('Position',{ns:'trans'})}</span>{positionButtons}
            </div>
        return(
            <div style={{position: 'relative'}}>
            {positionSelectDisplay}
            </div>
        )

    }

    render() {
        let detectorSelectDisplay; // =  this.makeDetectorSelectDisplay();
        if(this.props.isPrimary !== undefined){
            if(this.props.isPrimary){
                //Primary
                if(this.props.lanePosition !== undefined){
                    detectorSelectDisplay =  this.makeDetectorSelectDisplay();
                }
            } else {
                //Secondary
                detectorSelectDisplay =  this.makeDetectorSelectDisplay();
            }
        }
        let laneSelectDisplay;
        if(this.props.multiLane){
            laneSelectDisplay = this.makeLaneSelectDisplay();
        }
        let positionSelectDisplay;
        if(this.props.showByPositionType){
            positionSelectDisplay = this.makePositionSelectDisplay();
        }

        return (
            <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                {laneSelectDisplay}
                {detectorSelectDisplay}
                {positionSelectDisplay}
                <div style={{ display: 'flex', flexDirection: 'column', height: '50%' }}>
                <MemoizedBioResponseHistoryPlot data={this.bioLargeCount} data2={this.bioSmallCount} replayTime={this.props.replayTime} liveStream={this.props.liveStream}
                    onSelectRange={this.setSpectrumSumRange}  setStartTime={this.setLiveSpectrumSumStartTime}/>
                </div>
            </div>
        );
    }

}
export default BioDisplay


//******************************************************************************
export interface BioResponseHistoryPlotProps {
    data: BioCountData[],
    data2?: BioCountData[],
    replayTime?: Date,
    liveStream: boolean,
    onSelectRange?: (start_time: number | null, end_time: number | null) => void;
    setStartTime?: (start_time: number) => void;
}

export interface BioResponseHistoryPlotState {
    counthistory_log_scale: boolean,
}

export class BioResponseHistoryPlot extends React.Component<BioResponseHistoryPlotProps,BioResponseHistoryPlotState> {
    base: HTMLDivElement | null
    updateRef: (element: HTMLDivElement) => void
    previous_brush: [number, number] | undefined;

    plot_margin = { top: 20, right: 55, bottom: 30, left: 55 };
    plot1_count_rate_x: d3.ScaleTime<number, number> | null = null;
    plot1_count_rate_y: d3.ScaleContinuousNumeric<number, number> | null = null;
    plot1_count_rate_g: any | null
    plot2_count_rate_x: d3.ScaleTime<number, number> | null = null;
    plot2_count_rate_y: d3.ScaleContinuousNumeric<number, number> | null = null;
    plot2_count_rate_g: any | null
    count_rate_width: number = 0
    count_rate_height: number = 0
    source_brush: d3.BrushBehavior<unknown> | null = null;
    brush_path: any;
    history_plot_range_msec = 300000;
    plot_scale_min_plot1 = 10; //concentration units
    plot_scale_min_plot2 = 100; //concentration units
    plot_scale_plus_min = 50;

    constructor(props: BioResponseHistoryPlotProps) {
        super(props)
        this.base = null

        this.state = {
            counthistory_log_scale: false,
        }

        this.resize = this.resize.bind(this);
        this.set_counthistory_log_scale = this.set_counthistory_log_scale.bind(this);

        this.updateRef = (element: HTMLDivElement) => {
            this.base = element;
            this.renderPlot();
        };
    }

    componentDidMount() {
        this.initPlot()
        this.renderPlot();
        window.addEventListener("resize", this.resize);
    }

    componentDidUpdate(prevProps: BioResponseHistoryPlotProps, prevState: BioResponseHistoryPlotState) {
        if (this.props.data !== prevProps.data) {
            this.renderPlot();
        }
        if (this.state.counthistory_log_scale !== prevState.counthistory_log_scale) {
            //Switch plot scale
            this.renderPlot();
        }
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.resize);
    }

    resize() {
        this.initPlot()
        this.renderPlot();
    }

    set_counthistory_log_scale(flag: boolean) {
        this.setState(state => ({
            counthistory_log_scale: flag
        }));
    }

    on_source_brush() {
        if (this.plot1_count_rate_x !== null && this.plot1_count_rate_y !== null) {
            var sel = d3.event.selection || this.plot1_count_rate_x.range();
            var times = sel.map(this.plot1_count_rate_x.invert, this.plot1_count_rate_x);
            times[0] = Math.round(times[0] / 1000) * 1000;
            times[1] = Math.round(times[1] / 1000) * 1000;
            if (d3.event.selection !== null) {
                if (this.previous_brush === undefined) {
                    if(this.props.onSelectRange !== undefined){
                        this.props.onSelectRange(times[0], times[1])
                        this.previous_brush = times;
                    }
                } else {
                    if (this.previous_brush[0] !== times[0] || this.previous_brush[1] !== times[1]) {
                        if(this.props.onSelectRange !== undefined){
                            this.props.onSelectRange(times[0], times[1])
                            this.previous_brush = times;
                        }
                    }
                }
            } else {
                if (this.previous_brush !== undefined) {
                    if(this.props.onSelectRange !== undefined){
                        this.props.onSelectRange(null, null);
                        this.previous_brush = undefined;
                        if (this.source_brush !== null)
                            this.brush_path.call(this.source_brush.move, null);
                    }
                }
            }
        }
    }

    initPlot() {
        const width = this.base!.clientWidth - 20;  // subtract 20 to compensate for margins
        const height = this.base!.clientHeight - 20;

        this.count_rate_width = width -
            this.plot_margin.left - this.plot_margin.right;
        this.count_rate_height = height -
            this.plot_margin.top - this.plot_margin.bottom;

        d3.select(this.base!).select("svg").remove();

        const count_rate_svg = d3.select(this.base!).append("svg")
            .attr("width", `${width}px`)
            .attr("height", `${height}px`);

        //Neutron Plot
        this.plot2_count_rate_g = count_rate_svg.append('g').attr(
            'transform', 'translate(' + this.plot_margin.left + ',' +
            this.plot_margin.top + ')');

        this.plot2_count_rate_g.selectAll('.plot-axis').remove();
        this.plot2_count_rate_g.selectAll('path').remove();

        this.plot2_count_rate_x =
            d3.scaleTime().rangeRound([0, this.count_rate_width]);
        this.plot2_count_rate_y =
            d3.scaleLinear().rangeRound([this.count_rate_height,0]);

        //Gamma Plot
        this.plot1_count_rate_g = count_rate_svg.append('g').attr(
            'transform', 'translate(' + this.plot_margin.left + ',' +
            this.plot_margin.top + ')');

        this.plot1_count_rate_g.selectAll('.plot-axis').remove();
        this.plot1_count_rate_g.selectAll('path').remove();

        this.plot1_count_rate_x =
            d3.scaleTime().rangeRound([0, this.count_rate_width]);
        this.plot1_count_rate_y =
            d3.scaleLinear().rangeRound([this.count_rate_height, 0]);

        this.source_brush =
            d3.brushX().on('brush end', this.on_source_brush.bind(this));

        this.brush_path = this.plot1_count_rate_g.append('g')
            .attr('class', 'brush')
            .call(this.source_brush);
    }

    renderPlot() {
        if (this.plot1_count_rate_x !== null && this.plot1_count_rate_y !== null) {
            let max_all_x = 0;
            let min_plot_x = 0;

            //Plot Scale
            if (this.state.counthistory_log_scale) {
                this.plot1_count_rate_y = d3.scaleLog().rangeRound([this.count_rate_height, 0]);
                this.plot2_count_rate_y = d3.scaleLog().rangeRound([this.count_rate_height, 0]);
            } else {
                this.plot1_count_rate_y = d3.scaleLinear().rangeRound([this.count_rate_height, 0]);
                this.plot2_count_rate_y = d3.scaleLinear().rangeRound([this.count_rate_height, 0]);
            }

            //Find common x domain between gamma and neutron data
            if(this.props.data2 !== undefined && this.props.data2 !== null){
                //Neutron data exists
                if(this.plot2_count_rate_x !== null && this.plot2_count_rate_y !== null){
                    if(this.props.data.length > 0){
                        //Neutron and Gamma data exist
                        let max_gamma_x = d3.max(this.props.data, function (d) { return d.time }) || 0;
                        let min_gamma_x = d3.min(this.props.data, function (d) { return d.time }) || 0;

                        let max_neutron_x = d3.max(this.props.data2, function (d) { return d.time }) || 0;
                        let min_neutron_x = d3.min(this.props.data2, function (d) { return d.time }) || 0;

                        max_all_x = Math.max(max_gamma_x,max_neutron_x);
                        var min_all_x=0;
                        if(min_gamma_x > 0){
                            if(min_neutron_x > 0){
                                min_all_x = Math.min(min_gamma_x,min_neutron_x);
                            } else {
                                min_all_x = min_gamma_x;
                            }
                        } else {
                            if(min_neutron_x > 0){
                                min_all_x = min_neutron_x;
                            } else {
                                min_all_x = 0;
                            }
                        }

                        min_plot_x = min_all_x;

                        if(this.props.liveStream === true){
                            if(min_plot_x < max_all_x-this.history_plot_range_msec && min_plot_x > 0){
                                min_plot_x = max_all_x-this.history_plot_range_msec;
                            }
                        }

                        this.plot2_count_rate_x.domain([
                            min_plot_x,
                            max_all_x
                        ]);
                        this.plot1_count_rate_x = this.plot2_count_rate_x;

                    } else {
                        //Neutron data only
                        this.plot2_count_rate_x.domain([
                            d3.min(this.props.data2, function (d) { return d.time }) || 0,
                            d3.max(this.props.data2, function (d) { return d.time }) || 0
                        ]);
                        this.plot1_count_rate_x = this.plot2_count_rate_x;
                    }
                }

            } else {
                //Neutron data doesn't exist
                if(this.props.data.length > 0){
                    //Gamma data only
                    this.plot1_count_rate_x.domain([
                        d3.min(this.props.data, function (d) { return d.time }) || 0,
                        d3.max(this.props.data, function (d) { return d.time }) || 0
                    ]);
                    this.plot2_count_rate_x = this.plot1_count_rate_x;
                    const domain = this.plot1_count_rate_x.domain();
                    min_plot_x = domain[0].getTime();
                } else {
                    //NO VALID DATA

                }
            }
            if(this.props.setStartTime !== undefined)
                this.props.setStartTime(min_plot_x);

            //Y axis limits
            var plot1_maxval_y = 0;
            var plot1_minval_y = 100000;

            const validData = this.props.data.filter(function (d) { return d.count !== null }).filter(function (d) { return d.time >= min_plot_x});;
            this.plot1_count_rate_y.domain([
                d3.min(validData, function (d) { return d.count }) || 0,
                d3.max(validData, function (d) { return d.count }) || 0
            ]);

            //Find max and min of gamma
            if(this.plot1_count_rate_y.domain()[1] > plot1_maxval_y){
                plot1_maxval_y = this.plot1_count_rate_y.domain()[1];
            }
            if(this.plot1_count_rate_y.domain()[0] < plot1_minval_y){
                plot1_minval_y = this.plot1_count_rate_y.domain()[0];
            }

            //Set range for plots
            if (plot1_maxval_y < this.plot_scale_min_plot1){
                this.plot1_count_rate_y.domain([plot1_minval_y,this.plot_scale_min_plot1]);
            }

            const log_plot1_floor_val = 2e-1;
            if(!this.state.counthistory_log_scale && plot1_minval_y < 1){
                plot1_minval_y = 0; //If linear scale and min val is <1
            } else if (this.state.counthistory_log_scale) {
                plot1_minval_y = log_plot1_floor_val;
            }
            this.plot1_count_rate_y.domain([plot1_minval_y,this.plot1_count_rate_y.domain()[1]]);

            var xscale = this.plot1_count_rate_x;
            var yscale = this.plot1_count_rate_y;

            // clang-format off
            this.plot1_count_rate_g.selectAll('.plot-axis').remove();
            this.plot1_count_rate_g.selectAll('.replay-time').remove();
            this.plot1_count_rate_g.selectAll('path').remove();
            this.plot2_count_rate_g.selectAll('.neutron-plot-axis').remove();
            this.plot2_count_rate_g.selectAll('path').remove();

            //Gamma Plot
            this.plot1_count_rate_g.append('g')
                .attr('class', 'plot-axis')
                .attr('transform', 'translate(0,' + this.count_rate_height + ')')
                .call(d3.axisBottom(xscale).scale(xscale))

            this.plot1_count_rate_g.append('g')
                .attr('class', 'plot-axis')
                .call(d3.axisLeft(yscale).ticks(5,d3.format(",d")));
                //.call(d3.axisLeft(yscale).ticks(4).tickFormat(x => `${x.valueOf().toFixed(0)}`));

            this.plot1_count_rate_g.append('g')
                .attr('class', 'plot-axis')
                .append("text")

                // this makes it easy to centre the text as the transform is applied to the anchor
                .attr("text-anchor", "middle")

                // text is drawn off the screen top left, move down and out and rotate
                .attr("transform", "translate(-" + this.plot_margin.left * 0.7 + "," +
                    (this.count_rate_height / 2) + ")rotate(-90)")

                .attr("fill", 'olivedrab')
                .text(t("Large Bio. Particle [PLA]",{ns:'trans'}));

                if(this.state.counthistory_log_scale){
                    //log scale so remove zero points
                    this.plot1_count_rate_g.append('path')
                        .datum(this.props.data)
                        .attr('fill', 'none')
                        .attr('stroke', 'olivedrab')
                        .attr('stroke-width', 1.5)
                        .attr('d',d3.line()
                            .x(function (d: any) { return xscale(d.time) as number })
                            .y(function (d: any) { return (d.count > log_plot1_floor_val ? yscale(d.count) as number : yscale(log_plot1_floor_val) as number)})
                            .defined(function (d: any) { return d.count !== null; })
                            .defined(function (d: any) { return d.time > min_plot_x; })
                            //.defined(function (d: any) { return d.count >= log_plot1_floor_val; })
                    );
                } else {
                    this.plot1_count_rate_g.append('path')
                        .datum(this.props.data)
                        .attr('fill', 'none')
                        .attr('stroke', 'olivedrab')
                        .attr('stroke-width', 1.5)
                        .attr('d', d3.line()
                            .x(function (d: any) { return xscale(d.time) as number})
                            .defined(function (d: any) { return d.count !== null; })
                            .defined(function (d: any) { return d.time > min_plot_x; })
                            .y(function (d: any) { return yscale(d.count) as number })
                        );
                }

            //Small Bio Plot
            if(this.props.data2 !== undefined && this.props.data2 !== null){
                let validData2 = this.props.data2.filter(function (d) { return d.count !== null}).filter(function (d) { return d.time >= min_plot_x})
                const log_plot2_floor_val = log_plot1_floor_val;
                if(this.state.counthistory_log_scale){
                    validData2.forEach(el => {
                        if(el.count === 0)
                            el.count = log_plot2_floor_val;
                    });
                }
                if(this.plot2_count_rate_x !== null && this.plot2_count_rate_y !== null){

                    let plot2_maxval_y = 0;
                    let plot2_minval_y = 100000;
                    this.plot2_count_rate_y.domain([
                        d3.min(validData2, function (d) { return d.count }) || 0,
                        d3.max(validData2, function (d) { return d.count }) || 0
                    ]);

                    //Find max and min of gamma
                    if(this.plot2_count_rate_y.domain()[1] > plot2_maxval_y){
                        plot2_maxval_y = this.plot2_count_rate_y.domain()[1];
                    }
                    if(this.plot2_count_rate_y.domain()[0] < plot2_minval_y){
                        plot2_minval_y = this.plot2_count_rate_y.domain()[0];
                    }

                    //Set range for plots
                    if (plot2_maxval_y < this.plot_scale_min_plot2){
                        this.plot2_count_rate_y.domain([plot2_minval_y,this.plot_scale_min_plot2]);
                    }
                    if(!this.state.counthistory_log_scale && plot2_maxval_y < 1){
                        plot2_minval_y = 0; //If linear scale and min val is <1
                    } else if (this.state.counthistory_log_scale) {
                        plot2_maxval_y = log_plot1_floor_val;
                    }
                    this.plot2_count_rate_y.domain([plot2_minval_y,this.plot2_count_rate_y.domain()[1]]);

                    let neutron_xscale = this.plot2_count_rate_x;
                    let neutron_yscale = this.plot2_count_rate_y;

                    this.plot2_count_rate_g.append('g')
                        .attr('class', 'neutron-plot-axis')
                        .attr('transform', 'translate(0,' + this.count_rate_height + ')')
                        .call(d3.axisBottom(neutron_xscale).scale(neutron_xscale))


                    this.plot2_count_rate_g.append('g')
                        .attr('class', 'neutron-plot-axis')
                        .attr('transform', 'translate('+ this.count_rate_width + ',0)')
                        .call(d3.axisRight(neutron_yscale).ticks(5,d3.format(",d")));

                    this.plot2_count_rate_g.append('g')
                        .attr('class', 'neutron-plot-axis')
                        .append("text")
                        .attr("text-anchor", "middle")  // this makes it easy to centre the text as the transform is applied to the anchor
                        .attr("transform", "translate("+ (this.count_rate_width+this.plot_margin.right*0.70) +","+(this.count_rate_height/2)+")rotate(90)")  // text is drawn off the screen top left, move down and out and rotate
                        .attr("fill",'steelblue')
                        .text(t("Small Bio. Particle [PLA]",{ns:'trans'}));

                    if(this.state.counthistory_log_scale){
                        //log scale so remove zero points
                        this.plot2_count_rate_g.append('path')
                            .datum(validData2)
                            .attr('fill', 'none')
                            .attr('stroke', 'steelblue')
                            .attr('stroke-width', 1.5)
                            .attr('d',d3.line()
                                .x(function (d: any) { return neutron_xscale(d.time) as number })
                                .y(function (d: any) { return neutron_yscale(d.count) as number })
                                .defined(function (d: any) { return d.count !== null; })
                                .defined(function (d: any) { return d.time > min_plot_x; })
                                .defined(function (d: any) { return d.count > log_plot2_floor_val; })
                        );
                    } else {
                        //Linear scale so plot zero points
                        this.plot2_count_rate_g.append('path')
                            .datum(validData2)
                            .attr('fill', 'none')
                            .attr('stroke', 'steelblue')
                            .attr('stroke-width', 1.5)
                            .attr('d',d3.line()
                                .x(function (d: any) { return neutron_xscale(d.time) as number })
                                .y(function (d: any) { return neutron_yscale(d.count) as number })
                                .defined(function (d: any) { return d.count !== null; })
                                .defined(function (d: any) { return d.time > min_plot_x; })
                            );
                    }
                }
            }

            if (this.source_brush !== null) {
                if (this.previous_brush !== undefined) {
                    let xs = this.previous_brush.map(xscale);
                    if(xs[0] !== undefined && xs[1] !== undefined){
                        if (xs[0] < 0)
                            xs[0] = 0;

                        if (xs[1] > 0) {
                            this.brush_path.call(this.source_brush.move, xs);
                        } else {
                            this.previous_brush = undefined;
                            this.brush_path.call(this.source_brush.move, null);
                        }
                    }
                }
            }

            if (this.props.replayTime && !this.props.liveStream) {
                var pos = this.plot1_count_rate_x(this.props.replayTime);
                if (pos === undefined)
                    pos = 0;
                if (pos < 0)
                    pos = 0;
                if (pos > this.count_rate_width)
                    pos = this.count_rate_width;

                this.plot1_count_rate_g.append("line")
                    .attr('class', 'replay-time')
                    .attr("x1", pos)
                    .attr("y1", 0)
                    .attr("x2", pos)
                    .attr("y2", this.count_rate_height)
                    .style("stroke-width", 2)
                    .style("stroke", "red")
                    .style("fill", "none");
            }
        }
    }

    render() {
        //console.log('Render BioResponseHistoryPlot')
        let linearSelectClass;
        let logSelectClass;
        if (this.state.counthistory_log_scale) {
            linearSelectClass = "";
            logSelectClass = "active";
        } else {
            linearSelectClass = "active";
            logSelectClass = "";
        }
        return (
            <div className="Plot" style={{ display: 'flex', flex: '1', flexDirection: 'column' }}>
                <div className="header">
                    <span>{t('Biological Count History',{ns:'trans'})}</span>
                    <div className="icon-bar" style={{ paddingLeft: '10px', paddingBottom: '2px' }}>
                        <div className={"axis-type " + linearSelectClass} onClick={() => this.set_counthistory_log_scale(false)}>{t('LINEAR',{ns:'trans'})}</div>
                        <div className={"axis-type " + logSelectClass} onClick={() => this.set_counthistory_log_scale(true)}>{t('LOG',{ns:'trans'})}</div>
                    </div>
                </div>
                <div className="plot" ref={this.updateRef} style={{ display: 'flex', flex: '1', touchAction:'none' }} />
            </div>
        )
    }
}
const MemoizedBioResponseHistoryPlot = React.memo(BioResponseHistoryPlot, bioResponseHistoryPlottPropsAreEqual)
function bioResponseHistoryPlottPropsAreEqual(prevProps:BioResponseHistoryPlotProps,nextProps:BioResponseHistoryPlotProps){

    let flag = true;
    if(prevProps.liveStream !== nextProps.liveStream){
        flag = false;
    }
    if(prevProps.replayTime?.getTime() !== nextProps.replayTime?.getTime()){
        flag = false;
    }
    if(nextProps.data !== null && nextProps.data.length > 0){
        if(prevProps.data !== null && prevProps.data.length > 0){
            if(prevProps.data[prevProps.data.length-1].time !== nextProps.data[nextProps.data.length-1].time){
                flag = false;
            }
        } else {
            flag = false;
        }
    } else if (prevProps.data !== undefined && prevProps.data.length > 0){
        flag = false;
    } else if(nextProps.data2 !== undefined && nextProps.data2.length > 0){
        if(prevProps.data2 !== undefined && prevProps.data2.length > 0){
            if(prevProps.data2[prevProps.data2.length-1].time !== nextProps.data2[nextProps.data2.length-1].time){
                flag = false;
            }
        } else {
            flag = false;
        }
    }

    return (flag);
}
